import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function App({ changedValue, allData }) {
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          color: "#d7d7d7",
          text: "Year",
        },
        ticks: {
          color: "#d7d7d7",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
      y: {
        title: {
          display: true,
          color: "#d7d7d7",
          text: "(USD)",
        },
        ticks: {
          precision: 0,
          color: "#d5d5d5",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
    },
    plugins: {
      tooltip: {
        bodyColor: "#1e2936",
        backgroundColor: "#1e2936",
        callbacks: {
          labelTextColor: function (context) {
            return "#f8f8f8";
          },
        },
      },
      legend: {
        display: false,
        position: "bottom",
      },
    },
  };
  const [data, setData] = useState({
    labels: ["2025", "2026", "2027", "2028", "2029", "2030"],
    datasets: [
      {
        label: "OPEX",
        data: [12000, 10000, 24000, 26000, 12000, 9000],
        backgroundColor: "rgba(192,155,75,0.9)",
      },
    ],
  });
  const colors = [themeColor, "#f0ad4e", "#5cb85c", "#d9534f", "#5bc0de"];

  useEffect(() => {
    const labels = [];
    const data = [];
    allData.map((i) => {
      labels.push(i.year);
      data.push(i.opex);
    });
    const datasets = [
      {
        label: "OPEX",
        data: data,
        backgroundColor: "rgba(192,155,75,0.9)",
      },
    ];
    const newData = {
      labels,
      datasets,
    };
    setData(newData);
  }, [allData]);

  return data ? (
    <div style={{ position: "relative", height: "140px", width: "100%" }}>
      <Bar options={options} data={data} />
    </div>
  ) : (
    <div>
      <div className="spinner-grow text-primary"></div>
    </div>
  );
}
export default App;
